<template>
  <div class="page-content" style="overflow: auto;">
    <h1 class="page-title">{{ $locale("report.memberShip") }}</h1>
    <el-row :gutter="10" class="search-area">
      <el-col :span="15">
        <DatePickerGroup
          v-model="filter"
          :showWeekly="true"
        ></DatePickerGroup>
        <el-button
          class="egl-btn-yellow"
          @click="getList"
        >{{ $locale("global.search") }}</el-button>
      </el-col>
      <el-col :span="9" class="ta-r">
          <el-button class="egl-btn-yellow right-align-btn" @click="exportCSV_fn">{{ $locale("global.exportToCSV") }}</el-button>
          <el-button class="egl-btn-yellow" v-print="printObj">{{ $locale("global.printBtn") }}</el-button>
        </el-col>
    </el-row>
    <div id="print">
      <el-row>
        <el-col :span="19">{{ $locale("report.memberShip") }}</el-col>
        <el-col :span="5" style="text-align: right;">{{ `${$locale('trans.report.generatedate')}：${exportTime}` }}</el-col>
      </el-row>
      <p>{{ `${$locale('business.date')}：${time}` }}</p>
      <!-- table -->
      <el-row>
        <el-col :span="16" class="custom-border-table film-table memberShip">
          <el-table
            :data="tableData"
            class="egl-table list-table boxPeriod"
            border
            :span-method="newTableMerge"
            :cell-class-name="totalClassName"
          >
            <el-table-column
              align="center"
              prop="membershipId"
              :label="$locale('report.memberShip.memberType')"
              :formatter="(row, column, cellValue) => { return row.type === 'memberTotal' || row.type === 'allTotal' ? cellValue : (memberShipList.find(item => item.id === cellValue) || {}).name }"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="windowOnline"
              :label="$locale('report.memberShip.windowOnline')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="cinemaId"
              :label="$locale('report.memberShip.cinema')"
              :formatter="cinemaNameFormat_fn"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="createUpdate"
              :label="$locale('report.memberShip.createUpdate')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="personNum"
              :label="$locale('report.memberShip.personNum')"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="personNumTotal"
              :label="$locale('report.memberShip.personNumTotal')"
            ></el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import DatePickerGroup from "@/components/common/CommDatePickerGroup/DatePickerGroup.vue";
import { getMemberRptListService, getMemberShipOptionListService } from "@/helpers/service/api/report";
import { getCinemaList } from "@/helpers/service/api/common";
import { exportCSV_fn } from "@/assets/js/memberShip_exportCSV";
export default {
  data() {
    return {
      printObj: {
        popTitle: this.$locale("report.memberShip"),
        id: "print",
      },
      exportTime: 0,
      time: 0,
      filter: {
        startDate: new Date().valueOf(),
        endDate: new Date().valueOf(),
      },
      cinemaList: [],
      memberShipList: [],
      tableData: []
    };
  },
  created() {
    getCinemaList({
      page: 0,
      pageSize: 99999
    }).then(res => {
      if (res.data && res.data.data.length > 0) {
        this.cinemaList = res.data.data;
      }
    });
    getMemberShipOptionListService({ brandId: window.localStorage.getItem("brandId") }).then(res => {
      this.memberShipList = res.data.map(item => ({
        id: item.id,
        name: item.name
      }));
      getMemberRptListService({
        brandId: window.localStorage.getItem("brandId"),
        startTime: this.$moment().startOf("day").valueOf(),
        endTime: this.$moment().add(1, "days").startOf("day").valueOf(),
        page: 0,
        pageSize: 99999
      }).then(res => {
        this.exportTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        this.time = `${this.$moment(this.filter.startDate).format("YYYY-MM-DD")} 
          ~ ${this.$moment(this.filter.endDate).format("YYYY-MM-DD")}`;
        if (res.data && res.data.data.length > 0) {
          this.tableData = this.formatData_fn(res);
        }
      });
    });
  },
  methods: {
    genTwoData_fn(member, platform, type) {
      const _arr = [];
      for(let i = 0; i < 2; i++) {
        _arr.push({
          membershipId: member.membershipId,
          windowOnline: type === "window" ? "窓口" : "オンライン",
          cinemaId: platform.cinemaId,
          createUpdate: i === 0 ? "新規" : "更新",
          personNum: i === 0 ? platform.newJoinCount : platform.renewCount,
          personNumTotal: platform.newJoinCount + platform.renewCount
        });
      }
      return _arr;
    },
    genTwoDataTotal_fn(member, platForms) {
      const typeMapping = [
        { key: 0, label: "新規" },
        { key: 1, label: "更新" }
      ];
      
      // 提取公共属性
      const baseData = {
        type: "total",
        membershipId: member.membershipId,
        windowOnline: `合計（${(this.memberShipList.find(item => item.id === member.membershipId) || {}).name}、窓口）`,
        cinemaId: ""
      };
      
      // 预计算常用求和值
      const newJoinTotal = this.$_.sumBy(platForms, "newJoinCount");
      const renewTotal = this.$_.sumBy(platForms, "renewCount");
      const baseTotal = newJoinTotal + renewTotal;
      
      // 生成数据项
      const generateItem = (type, personNum, personNumTotal) => ({
        ...baseData,
        createUpdate: type,
        personNum,
        personNumTotal
      });
      
      return [
        generateItem(typeMapping[0].label, newJoinTotal, baseTotal),
        generateItem(typeMapping[1].label, renewTotal, baseTotal)
      ];
    },
    genTwoDataMemberTotal_fn(member, offline, online, expiredData) {
      const typeMapping = [
        { key: 0, label: "新規" },
        { key: 1, label: "更新" },
        { key: 2, label: "有効期限切れ" }
      ];
      
      // 提取公共属性
      const baseData = {
        type: "memberTotal",
        membershipId: `合計（${(this.memberShipList.find(item => item.id === member.membershipId) || {}).name}）`,
        windowOnline: "",
        cinemaId: ""
      };
      
      // 预计算常用求和值
      const newJoinTotal = this.$_.sumBy(offline, "newJoinCount") + this.$_.sumBy(online, "newJoinCount");
      const renewTotal = this.$_.sumBy(offline, "renewCount") + this.$_.sumBy(online, "renewCount");
      const expiredTotal = expiredData && expiredData.expiredCount !== undefined ? expiredData.expiredCount : 0;
      const totalSum = newJoinTotal + renewTotal + expiredTotal;
      
      // 生成数据项
      const generateItem = (type, personNum) => ({
        ...baseData,
        createUpdate: type,
        personNum,
        personNumTotal: totalSum
      });
      
      const _arr = [
        generateItem(typeMapping[0].label, newJoinTotal),
        generateItem(typeMapping[1].label, renewTotal)
      ];
      
      // 添加过期数据（如果存在）
      if (expiredData && expiredData.expiredCount !== undefined) {
        _arr.push(generateItem(typeMapping[2].label, expiredTotal));
      }
      
      return _arr;
    },
    genAllDataTotal_fn(data) {
      const typeMapping = [
        { key: 0, label: "新規" },
        { key: 1, label: "更新" },
        { key: 2, label: "有効期限切れ" }
      ];
      
      // 提取公共属性
      const baseData = {
        type: "allTotal",
        membershipId: "合計（全て）",
        windowOnline: "",
        cinemaId: ""
      };
      
      const _data = this.$_.cloneDeep(data);
      
      // 预计算常用求和值
      const newJoinData = _data.filter(item => item.type === "memberTotal" && item.createUpdate === "新規");
      const renewData = _data.filter(item => item.type === "memberTotal" && item.createUpdate === "更新");
      const expiredData = _data.filter(item => item.type === "memberTotal" && item.createUpdate === "有効期限切れ");
      
      const newJoinTotal = this.$_.sumBy(newJoinData, "personNum");
      const renewTotal = this.$_.sumBy(renewData, "personNum");
      const expiredTotal = this.$_.sumBy(expiredData, "personNum");
      const totalSum = newJoinTotal + renewTotal + expiredTotal;
      
      // 生成数据项
      const generateItem = (type, personNum) => ({
        ...baseData,
        createUpdate: type,
        personNum,
        personNumTotal: totalSum
      });
      
      return [
        generateItem(typeMapping[0].label, newJoinTotal),
        generateItem(typeMapping[1].label, renewTotal),
        generateItem(typeMapping[2].label, expiredTotal)
      ];
    },
    totalClassName({ row, columnIndex }) {
      if (row.type === "total" && columnIndex === 1) {
        return "total";
      } else if ((row.type === "memberTotal" || row.type === "allTotal") && (columnIndex === 0 || columnIndex === 4 || columnIndex === 5)) {
        return "memberTotal";
      }
    },
    formatData_fn(res) {
      let _arr = [];
      res.data.data.forEach(item => {
        item.membership.forEach(member => {
          member.offlinePayment.forEach(offline => {
            _arr = [..._arr, ...this.genTwoData_fn(member, offline, "window")];
          });
          _arr = [..._arr, ...this.genTwoDataTotal_fn(member, member.offlinePayment)];
          member.onlinePayment.forEach(online => {
            _arr = [..._arr, ...this.genTwoData_fn(member, online, "online")];
          });
          _arr = [..._arr, ...this.genTwoDataMemberTotal_fn(member, member.offlinePayment, member.onlinePayment, member.expiredData)];
        });
      });
      _arr = [..._arr, ...this.genAllDataTotal_fn(_arr)];
      return _arr;
    },
    cinemaNameFormat_fn(row, column, cellValue) {
      if (!cellValue) {
        return "ー";
      }
      return (this.cinemaList.find(item => item.id === cellValue) || {}).name;
    },
    getList() {
      getMemberRptListService({
        startTime: this.$moment(this.filter.startDate).startOf("day").valueOf(),
        endTime: this.$moment(this.filter.endDate).add(1, "days").startOf("day").valueOf(),
        brandId: window.localStorage.getItem("brandId"),
        page: 0,
        pageSize: 99999
      }).then(res => {
        this.tableData = [];
        this.exportTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
        this.time = `${this.$moment(this.filter.startDate).format("YYYY-MM-DD")} 
          ~ ${this.$moment(this.filter.endDate).format("YYYY-MM-DD")}`;
        if (res.data && res.data.data.length > 0) {
          this.tableData = this.formatData_fn(res);
        }
      });
    },
    exportCSV_fn() {
      exportCSV_fn(this.tableData, this.memberShipList, this.cinemaList);
      // getMemberRptListService({
      //   startTime: this.$moment(this.filter.startDate).startOf("day").valueOf(),
      //   endTime: this.$moment(this.filter.endDate).add(1, "days").startOf("day").valueOf(),
      //   brandId: window.localStorage.getItem("brandId"),
      //   page: 0,
      //   pageSize: 99999
      // }).then(res => {
      //   if (res.data && res.data.data.length > 0) {
      //     const _arr = this.formatData_fn(res);
      //     exportCSV_fn(_arr, this.memberShipList, this.cinemaList);
      //   }
      // });
    },
    getCount(model, key) {
      let spanArr = [];
      let pos = 0;
      const validArrs = ["personNumTotal", "cinemaId"];
      for (let i = 0; i < model.length; i++) {
        if (i === 0) {
          spanArr.push(1);
          pos = 0;
        } else if (key === "personNumTotal" && model[i][key] === model[i - 1][key] &&
        model[i].membershipId === model[i - 1].membershipId && model[i].type === model[i - 1].type) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else if (key === "cinemaId" && model[i][key] === model[i - 1][key] &&
        model[i].windowOnline === model[i - 1].windowOnline)  {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else if (!validArrs.includes(key) && model[i][key] === model[i - 1][key]) {
          spanArr[pos] += 1;
          spanArr.push(0);
        } else {
          spanArr.push(1);
          pos = i;
        }
      }
      return spanArr;
    },
    getTotalMerge(columnIndex, type) {
      if (type && (type === "total")) {
        if (columnIndex === 1) {
          return 2;
        } else if (columnIndex === 2) {
          return 0;
        }
        return 1;

      } else if (type && (type === "memberTotal" || type === "allTotal")) {
        if (columnIndex === 0) {
          return 3;
        } else if (columnIndex > 0 && columnIndex < 3) {
          return 0;
        } else if (columnIndex === 5) {
          // personNumTotal列合并显示所有三个类别
          return 3;
        }
        return 1;

      }
      return 1;
    },
    mergeComon(key, rowIndex, columnIndex) {
      const _row = this.getCount(this.tableData, key)[rowIndex];
      return {
        rowspan: _row,
        colspan: this.getTotalMerge(columnIndex, this.tableData[rowIndex].type)
      };
    },
    newTableMerge({ rowIndex, columnIndex }) {
      switch(columnIndex) {
      case 0:
        return this.mergeComon("membershipId", rowIndex, columnIndex);
      case 1:
        return this.mergeComon("windowOnline", rowIndex, columnIndex);
      case 2:
        return this.mergeComon("cinemaId", rowIndex, columnIndex);
      case 3:
        return this.mergeComon("createUpdate", rowIndex, columnIndex);
      case 5:
        return this.mergeComon("personNumTotal", rowIndex, columnIndex);
      default:
        break;
      }
    },
  },
  components: {
    DatePickerGroup
  },
};
</script>
<style lang="less" scoped>
  .memberShip::v-deep {
    .total, .memberTotal {
      font-weight: 600;
      color: #181818;
    }
  }
</style>